export enum EDocType {
  ACCESS_MAP = 'ACCESS_MAP',
  BUS_LIC = 'BUS_LIC',
  CAP_ATTACHMENT = 'CAP_ATTACHMENT',
  CERT_ORIGIN = 'CERT_ORIGIN',
  CHECKLIST_DEFECT = 'CHECK_LIST_DEFECT',
  CHECKLIST_TEST = 'CHECK_LIST_TEST',
  CUST_ATT = 'CUST_ATT',
  ENTITY_PHOTO = 'ENTITY_PHOTO',
  EXPORT_LIC = 'EXPORT_LIC',
  EXTERNAL_DOCUMENT = 'EXTERNAL_DOCUMENT',
  FAC_AUDIT_REPORT = 'FAC_AUDIT_REPORT',
  FOOD_CERT_ANNEX_022A = 'FOOD_CERT_ANNEX_022A',
  FOOD_CERT_HARVEST_EXCLUSION_CONTRACT_INFO = 'FOOD_CERT_HARVEST_EXCLUSION_CONTRACT_INFO',
  FOOD_CERT_RENTED_SITE_CONTRACT_INFO = 'FOOD_CERT_RENTED_SITE_CONTRACT_INFO',
  FOOD_CERT_VALID_CERTIFICATE = 'FOOD_CERT_VALID_CERTIFICATE',
  HACCP_FLOW_DIAGRAM = 'HACCP_FLOW_DIAGRAM',
  ISO_CERT = 'ISO_CERT',
  NC_CA_EVIDENCE = 'NC_CA_EVIDENCE',
  ORDER_ATT = 'ORDER_ATT',
  OTHER_DOC = 'OTHER_DOC',
  PREVIOUS_REPORT = 'PREVIOUS_REPORT',
  PROD_FINAL_REPORT = 'PROD_FINAL_REPORT',
  PROD_REPORT_PICTURE = 'PROD_REPORT_PICTURE',
  REPORT_IMAGE_ZIP = 'REPORT_IMAGE_ZIP',
  ROHS_CERT = 'ROHS_CERT',
  TAX_CERT = 'TAX_CERT',
  TEST_REPORT = 'TEST_REPORT',
  USER_COMMENT_ATTACHMENT = 'USER_COMMENT_ATTACHMENT',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  WQS_BUCKET = 'WQS_BUCKET',
  WQS_CERTIFICATION_PREVIOUSLY_CERTIFIED = 'WQS_CERTIFICATION_PREVIOUSLY_CERTIFIED',
  WQS_CERTIFICATION_RENEWAL = 'WQS_CERTIFICATION_RENEWAL',
}
